import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const CreateTeamsTabPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-createteamstabpage" */ "./CreateTeamsTabPage")).then((bundle)=>{
        return {
            default: bundle.CreateTeamsTabPage
        };
    });
export const LazyCreateTeamsTabPage = /*#__PURE__*/ lazy(CreateTeamsTabPageLazyLoader);
